import React, { useState } from "react";
import { Band, Glow, Eyebrow, Reveal } from "./shared";
import { EXPLAINER_VIDEO_URL, VIDEO_POSTER_IMG } from "./content";

export function VideoSection() {
  const [play, setPlay] = useState(false);
  const isEmbed = /youtube|youtu\.be|vimeo/.test(EXPLAINER_VIDEO_URL);

  return (
    <Band id="video">
      <Glow className="top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-[#22D3EE]/8" />
      <Reveal>
        <div className="text-center max-w-3xl mx-auto">
          <Eyebrow className="text-[#22D3EE]">Watch</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white mt-3 leading-[1.05]">
            See how it works
          </h2>
          <p className="text-base sm:text-lg text-[#C7D6EA] mt-4 leading-relaxed">
            Meet Collon Brown, creator of the Freedom From Back Pain Course and inventor of the Back Pain Transformer.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-12 max-w-4xl mx-auto">
          <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-black aspect-video shadow-[0_30px_80px_rgba(0,0,0,0.6)]" data-testid="explainer-video">
            {play && EXPLAINER_VIDEO_URL ? (
              isEmbed ? (
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src={`${EXPLAINER_VIDEO_URL}${EXPLAINER_VIDEO_URL.includes("?") ? "&" : "?"}autoplay=1&rel=0`}
                  title="Explainer video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              ) : (
                <video className="absolute inset-0 w-full h-full" src={EXPLAINER_VIDEO_URL} controls autoPlay />
              )
            ) : (
              <button
                onClick={() => EXPLAINER_VIDEO_URL && setPlay(true)}
                data-testid="video-play"
                className="absolute inset-0 w-full h-full group"
              >
                <img src={VIDEO_POSTER_IMG} alt="Explainer video" className="w-full h-full object-cover object-center" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#040814]/70 to-transparent" />
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                  <div className="w-20 h-20 rounded-full bg-white/10 backdrop-blur-md border border-white/30 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <svg className="w-8 h-8 text-white ml-1" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                  </div>
                  <span className="mt-4 text-sm uppercase tracking-[0.2em] text-white/80">
                    {EXPLAINER_VIDEO_URL ? "Play the explainer" : "Explainer video coming soon"}
                  </span>
                </div>
              </button>
            )}
          </div>
        </div>
      </Reveal>
    </Band>
  );
}
